module.exports = __webpack_public_path__ + "media/church.8ebf361a.jpg";